/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Component } from 'react'
import {
  DatePicker,
  Popconfirm,
  Button,
  Divider,
  Input,
  InputNumber,
  Select,
  Icon,
  Table,
  Modal,
  Pagination,
  message,
  Spin,
  Tabs,
  Switch,
  Tooltip,
} from 'antd'
import moment from 'moment'
import R from 'ramda'
import { conCodes, fixDescriptionValue } from '../../utils'
import styled from 'styled-components'
import { GenericModal, timeZoneIdentMap, UtilityUnitSelection } from 'core'
import {
  // postCard97,
  // deleteCard97,
  getCard97ExtensionSpec,
  getCard97NextEventNumber,
  // getContribCondtition,
  // getCard97DataCheck,
} from 'api/pgads'

import {
  getDataCheckServiceByclient,
  getSaveServiceByClient,
  getDeleteServiceByClient,
  getExtensionPanel,
  isAvaliableExtensionPanel,
} from './../../getServiceUtil'

import CardsErrorDialog from '../../CardErrorDialogAntd'
import FailCodePrompt from './FailCodePromptAntd'
import MultiCauseCodePropmt, {
  generateCauseCodeKey,
} from '../../MultiCauseCode'
import LowerTablePrompt from './LowerTablePrompt'
// import InsertHeader from './InsertHeader'
import DescWizard from './DescWizard'
import { SpinContext, ErrorContext } from 'context'
import { connect } from 'react-redux'
import {
  getFailCode,
  isAdminType,
  getAmlificationCode,
  getEventTypes,
  getUnits,
  getPermitActions,
  getEnvConfig,
  getCauseCodeMap,
  getContribOperCondition,
  getContribOperConditionMap,
} from 'core/selectors'

import {
  CARD97_DIALOG_MANHOURS_HIDE,
  CARD97_DIALOG_MORE_CAUSE_HIDE,
  CARD97_DIALOG_WORKDATE_HIDE,
} from 'core/EventActions'
import { freeEditEngine } from '@integec/grid-tools'
import { SRP_CLIENT, BROOKFIELD_CLIENT, DOM_CLIENT } from 'client'
import { CALPLINE_CLIENT, CPS_CLIENT } from '../../../client'
import { isErrorContainsTmpError } from 'core/component/JcTmpErrorDialog'
import { getSystemConfigurationInfo } from '../../../api/pgads'

export const ContentDiv = styled.div`
  margin-bottom: 5px;
  display: flex;
`
export const HeaderDiv = styled.div`
  padding-bottom: 10px;
  padding-top: 10px;
  background-color: lightgrey;
`
export const HeaderTag = styled.h4`
  margin-left: 10px;
  font-weight: bold;
  color: darkblue;
`
// justify-content: space-around;
/* const SubDiv = styled.div`
  margin-left: 5px;
  display: inline-grid;
  width: 100%;
` */
export const SubDiv = styled.div`
  margin-left: 5px;
  margin-bottom: 5px;
`
export const Labeled = styled.label`
  background-color: white;
  align-self: center;
  font-weight: 500;
  margin-top: 10px;
`
const Label = styled.div`
  padding-right: 10px;
  align-self: center;
`

// if eventType is IE then need to get event type from extension
export const getDataEventType = data => {
  if (data.eventType !== 'IE') return data.eventType
  else return (data.extension || {}).eventTypeInternal || data.eventType
}

const curYear = new Date().getFullYear()
const yearOption = R.range(curYear - 18, curYear + 4)
  .sort((a, b) => b - a)
  .map(i => (
    <Select.Option key={i} value={i}>
      {i}
    </Select.Option>
  ))

const getCard97DominantMap = (unl, avalDom) =>
  unl
    .map(u => ({
      [u.utility + u.unit]: avalDom && ['MISO', 'NERC'].includes(u.ruleSet),
    }))
    .reduce((a, b) => ({ ...a, ...b }))

export const getExpandedKeys = unitCodeCauseCodeMap => (
  unitType,
  causeCode
) => {
  if (unitType === undefined || causeCode === undefined) return []
  const val = unitCodeCauseCodeMap[unitType]
  const vd = R.flatten(
    (Object.keys(val || {}) || []).map(v1 =>
      Object.keys(val[v1]).map(va =>
        val[v1][va].filter(a => a.causeCode === causeCode)
      )
    )
  )
  return {
    causeCodeValues: vd,
    causeCodeKeyValues: vd.map(v => generateCauseCodeKey(v)),
  }
}

// const updateIoCodeForRetrieve = dataObj => {
//   return {
//     ...dataObj,
//     ioCode:
//       (dataObj.ioCode || '0') === 'Y' ||
//       (dataObj.ioCode || '0') === '-1' ||
//       (dataObj.ioCode || '0') === -1
//         ? -1
//         : 0,
//   }
// }

export const setDstZone = (date, dateZone, timeZoneMap, unit, unitsList) => {
  const daylightSavings = unitsList.find(u => u.unitId === unit) || {}

  // daylightSavings = daylightSavings.daylightSavings || 'N'
  if (daylightSavings.daylightSavings !== 'Y')
    return daylightSavings.timeZone || ''

  return (
    dateZone ||
    (date
      ? moment(
          moment(date).format('MM/DD/YYYY HH:mm'),
          'MM/DD/YYYY HH:mm'
        ).isDST()
        ? timeZoneMap &&
          timeZoneMap[unit] &&
          `${timeZoneMap[unit].substring(0, 1)}D${timeZoneMap[unit].substring(
            2,
            3
          )}`
        : timeZoneMap && timeZoneMap[unit]
      : '')
  )
}

class Card97EditPrompt extends Component {
  constructor(props) {
    super(props)
    this.ClintExtensionPanel = getExtensionPanel(props.CLIENT || 'INTEG')
    // this.isAdmin = isAdminType(props.apiTargetInfo)
    this.isAdmin = props.isAdmin || props.isAdminType
    this.eventTypeRef = React.createRef()
    this.showMoreCause = !props.actionPermits.includes(
      CARD97_DIALOG_MORE_CAUSE_HIDE
    )
    this.showManHours = !props.actionPermits.includes(
      CARD97_DIALOG_MANHOURS_HIDE
    )
    this.showWorkDates = !props.actionPermits.includes(
      CARD97_DIALOG_WORKDATE_HIDE
    )
  }

  state = {
    ...this.props,
    ...this.props.rowData,
    ioCode:
      (this.props.rowData.ioCode || this.props.ioCode || '0') === '-1' ||
      (this.props.rowData.ioCode || this.props.ioCode || '0') === -1 ||
      (this.props.rowData.ioCode || this.props.ioCode || '0') === 'Y'
        ? '-1'
        : '0',
    extensionData: {
      year: this.props.rowData.year || this.props.year,
      utility: this.props.rowData.utility || this.props.utility,
      unit: this.props.rowData.unit
        ? this.props.rowData.unit.substring(this.props.rowData.utility.length)
        : undefined || this.props.unit,
      eventNum: this.props.rowData.eventNum || this.props.eventNum,
    },
    extensionSpec: { avaliable: false },
    errors: [],
    idxData: this.props.idxData,
    tab: 'main',
    card97DominantMap: getCard97DominantMap(
      this.props.units,
      this.props.card97Dominant
    ),
    pageOptions: [],
    descWizard: false,
    ...getExpandedKeys(this.props.unitCodeCauseCodeMap || {})(
      this.props.unitCodeMap[this.props.unit || this.props.rowData.unit],
      this.props.causeCode || this.props.rowData.causeCode
    ),
    contribConditionMap: {},
  }

  handleExtensionData = (id, val, dataModified = true) => {
    this.setState({ extensionData: { ...this.state.extensionData, [id]: val } })
    this.setState({ dataModified: dataModified, dataModified1: dataModified })
  }

  // const [pageOptions, setPageOptions] = useState([])
  setPageOptions = pageOptions => this.setState({ pageOptions })

  // setErr = err => this.setState({ err, loading: false })
  setMsg = m => {
    this.setState({ msg: m })
    this.props.setSpinning(false)
  }

  onClose = () => this.setState({ msg: undefined })
  closeErrorPrompt = _ => this.setState({ errorPrompt: false })
  openLowerTablePrompt = (d, i, m) =>
    this.setState({ lowerTableDialog: d, tableRowIndex: i, tableMode: m })

  setLowerTableData = (toshow, editData) => {
    const mdata = {
      ...this.state.idxData[this.state.tableRowIndex],
      ...editData,
      // extension: {
      //   ...(this.state.idxData[this.state.tableRowIndex] || {}).extension,
      // },
    }

    const idata = [...this.state.idxData]
    idata[this.state.tableRowIndex] = mdata
    this.setState({
      lowerTableDialog: toshow,
      idxData: idata,
      dataModified: true,
    })
  }

  openFailCodePrompt = d => this.setState({ failCodeDialog: d })
  setFailAmpCode = (d, failCode, ampCode) => {
    this.setState({ dataModified: true })
    this.setState({ failCodeDialog: d, failCode, ampCode })
  }

  openTableFailCodePrompt = (d, i) =>
    this.setState({ tableFailCodeDialog: d, tableRowIndex: i })

  openCauseCodePrompt = d => this.setState({ causeCodeDialog: d })
  // openTableCauseCodePrompt = (d, val, i) =>
  //   this.setState({ tableCauseCodeDialog: d, tableCauseCode: val, tableRowIndex: i })

  onCauseCodeTreeCancel = causeCodeKeyValues => {
    this.setState({
      causeCodeKeyValues,
      causeCodeDialog: false,
    })
  }

  onDescWizardDialogClosed = desc => {
    this.setState({
      descWizard: false,
      description: fixDescriptionValue(desc, true, true),
      dataModified: true,
    })
    // this.setState({description:desc})
  }

  onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    this.setState({
      causeCodeDialog: false,
      causeCodeKeyValues,
      causeCodeValues,
      causeCode: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : this.state.causeCode,
      dataModified: true,
    })
  }

  setTableFailAmpCode = (d, failCode, ampCode) => {
    this.state.idxData[this.state.tableRowIndex].failCode = failCode
    this.state.idxData[this.state.tableRowIndex].ampCode = ampCode
    this.setState({ tableFailCodeDialog: d, idxData: [...this.state.idxData] })
  }

  save = ({ againNew = false }) => {
    const { mode = 'N', unitShortNameMap, CLIENT = 'INTEG' } = this.props
    const {
      utility,
      unit,
      year,
      idxData,
      eventType,
      eventStart,
      isRequiredContribOperCond,
      extensionData = {},
    } = this.state
    if (mode === 'V') {
      // this.setState({ loading: false })
      this.props.setSpinning(false)
      this.props.setEditPromptvisible && this.props.setEditPromptvisible(false)
      return
    }
    if (
      utility === undefined ||
      unit === undefined ||
      utility == null ||
      unit == null
    ) {
      message.error('Please,Select Unit')
      return
    }
    // if (!causeCode) {
    //   message.error('Please,Select CauseCode')
    //   return
    // }
    if (!eventType) {
      message.error('Please,Select Event Type')
      return
    }
    if (!eventStart) {
      message.error('Please,Select Event Start Time')
      return
    }
    if (isRequiredContribOperCond) {
      const conOpcond = (extensionData || {}).eventTypeExternal
      if (!conOpcond) {
        message.error('Please,Select Contributing Operating Condition')
        return
      }
    }
    let avlCap = this.state.availCap && this.state.availCap.trim()
    avlCap = avlCap ? (avlCap === 'NC' ? -1 : avlCap) : 0

    if (this.state.eventNum && this.state.eventNum.length > 4) {
      this.setMsg(
        'Event Number field can only contain numeric value less than 10000'
      )
    } else if (isNaN(avlCap)) {
      this.setMsg(
        'Available Capacity field can only contain "NC" as string besides numeric value'
      )
    } else if (
      this.state.ampCode &&
      this.state.ampCode.trim().length > 0 &&
      this.state.ampCode.trim().length !== 2
    ) {
      this.setMsg('Amplification Code can only have two characters.')
    } else if (
      this.state.failCode &&
      this.state.failCode.trim().length > 0 &&
      this.state.failCode.trim().length !== 4
    ) {
      this.setMsg('Fail Code can only have four characters.')
    } else {
      const tableData =
        idxData.length > 0
          ? idxData
              // .filter(c => c.causeCode && (c.causeCode + '').length > 0)
              .map((d, i) => ({
                // utility: mode === 'N' ? this.props.criteriaUtility : utility,
                // unit: mode === 'N' ? this.props.criteriaUnit : unit,
                // year: mode === 'N' ? new Date().getFullYear() : year,
                utility,
                unit,
                year,
                eventNum:
                  this.state.eventNum &&
                  this.state.eventNum.length > 0 &&
                  this.state.eventNum.length <= 4
                    ? this.state.eventNum
                    : -1,
                eventIdx: i + 1,
                causeCode: d.causeCode,
                conCode: d.conCode ? d.conCode : '',
                failCode: d.failCode ? d.failCode : '',
                ampCode: d.ampCode ? d.ampCode : '',
                description: d.description ? d.description : '',
                eventType: this.state.eventType,
                extensionData: {
                  utility,
                  unit: unit.substring(utility.length),
                  year,
                  eventNum: this.state.eventNum || -1,
                  eventTypeExternal: (d.extension || {}).eventTypeExternal,
                },
              }))
          : []

      let spillData = []

      if (CLIENT === BROOKFIELD_CLIENT && (mode === 'N' || mode === 'E')) {
        spillData = freeEditEngine.applyEdits({
          data: this.state.extensionData.spillData || [],
          editInfo:
            this.state.extensionData.editInfo ||
            freeEditEngine.generateInitialEditInfo(),
        })

        spillData = spillData.map(d => ({
          ...d,
          spillStart: moment
            .tz(
              moment(d.spillStartMod, 'MM/DD/YYYY HH:mm').format(
                'YYYY-MM-DDTHH:mm:ss'
              ),
              timeZoneIdentMap[this.state.eventStartZone]
            )
            .utc()
            // .tz(timeZoneIdentMap[this.state.eventStartZone])
            .format('YYYY-MM-DDTHH:mm.ss'),
          spillEnd: moment
            .tz(
              moment(d.spillEndMod, 'MM/DD/YYYY HH:mm').format(
                'YYYY-MM-DDTHH:mm:ss'
              ),
              timeZoneIdentMap[this.state.eventStartZone]
            )
            // .utc(d.spillEndMod, 'MM/DD/YYYY HH:mm')
            .utc()
            // .tz(timeZoneIdentMap[this.state.eventStartZone])
            .format('YYYY-MM-DDTHH:mm.ss'),
        }))
      }
      const data = [
        {
          mode: mode === 'N' ? 1 : 0,
          shortName: unitShortNameMap[unit],
          utility,
          unit,
          year,
          eventNum: this.state.eventNum || -1,
          eventIdx: mode === 'D' ? 1 : 0,
          // eventIdx: mode === 'D' && CLIENT !== DOM_CLIENT ? 1 :0 ,
          eventType: this.state.eventType ? this.state.eventType : '',
          // ioCode: this.state.ioCode === 'Y' ? -1 : 0,
          ioCode:
            this.state.ioCode === 'na'
              ? undefined
              : this.state.ioCode === 'N'
              ? '0'
              : this.state.ioCode,
          eventStart: this.state.eventStart
            ? moment(this.state.eventStart).format('MM/DD/YYYY HH:mm')
            : '',
          eventStartZone: this.state.eventStartZone
            ? this.state.eventStartZone
            : '',
          eventEnd: this.state.eventEnd
            ? moment(this.state.eventEnd).format('MM/DD/YYYY HH:mm')
            : '',
          eventEndZone: this.state.eventEndZone ? this.state.eventEndZone : '',
          availCap: avlCap,
          causeCode: this.state.causeCode ? this.state.causeCode : null,
          conCode: this.state.conCode ? this.state.conCode : '',
          workStart: this.state.workStart
            ? moment(this.state.workStart).format('MM/DD/YYYY HH:mm')
            : '',
          workStartZone: this.state.workStartZone
            ? this.state.workStartZone
            : '',
          workEnd: this.state.workEnd
            ? moment(this.state.workEnd).format('MM/DD/YYYY HH:mm')
            : '',
          workEndZone: this.state.workEndZone ? this.state.workEndZone : '',
          manHour:
            this.state.manHour && parseFloat(this.state.manHour) > 0
              ? this.state.manHour
              : 0,
          description: this.state.description
            ? this.state.description.trim()
            : '',
          failCode: this.state.failCode ? this.state.failCode : '',
          ampCode: this.state.ampCode ? this.state.ampCode : '',
          delta: 0.0,
          extensionData: {
            ...R.omit(['editInfo'], this.state.extensionData), // ...this.state.extensionData,
            utility,
            unit: unit.substring(utility.length),
            year,
            eventNum: this.state.eventNum || -1,
            spillData,
            eventTypeExternal:
              this.state.extensionData.eventTypeExternal || '0',
          },
        },
        ...tableData,
      ]
      // this.setState({ loading: true })
      this.props.setSpinning(true)
      if (mode === 'D')
        // this.setState({ loading: true })
        getDeleteServiceByClient(CLIENT)(this.props.apiTargetInfo)(data).fork(
          e => this.props.setError(e, this.props.setEditPromptvisible),
          saveStatusData => {
            this.props.setSpinning(false)
            const isArray = Array.isArray(saveStatusData)
            const errorData = isArray
              ? saveStatusData
              : saveStatusData.errorData || []
            const curCard = isArray
              ? []
              : saveStatusData.dataForSingleEventNumber

            const isError = isErrorContainsTmpError(errorData)
            if (!isError) {
              if (errorData.length <= 0)
                message.info('Data deleted successfully.')

              if (
                (isArray && this.props.retrieveData && errorData.length <= 0) ||
                (this.props.allowRetrieve && errorData.length <= 0)
              )
                this.props.retrieveData({})
              else
                this.props.setData &&
                  this.props.setData(curCard, this.state.mode)
            }

            if (errorData.length > 0) {
              this.setState({
                errors: errorData,
                onlyWarning: !isError,
                errorPrompt: true,
                action: 'delete',
              })
            }
            if (!isError && errorData.length <= 0) {
              this.props.setEditPromptvisible &&
                this.props.setEditPromptvisible(false)
            }
          }
        )
      else {
        getSaveServiceByClient(CLIENT)(this.props.apiTargetInfo)(data).fork(
          e => this.props.setError(e),
          saveStatusData => {
            this.props.setSpinning(false)
            const isArray = Array.isArray(saveStatusData)
            const errorData = isArray
              ? saveStatusData
              : saveStatusData.errorData
            const curCard = isArray
              ? []
              : saveStatusData.dataForSingleEventNumber

            const isError = isErrorContainsTmpError(errorData)

            if (errorData.length > 0) {
              this.setState({
                errors: errorData,
                onlyWarning: !isError,
                errorPrompt: true,
                action: 'save',
                againNew,
              })
            }
            if (!isError) {
              if (errorData.length <= 0) message.info('Data saved successfully')

              if (
                (this.props.allowRetrieve && errorData.length <= 0) ||
                (isArray && this.props.retrieveData && errorData.length <= 0)
              )
                this.props.retrieveData({})
              else
                this.props.setData &&
                  this.props.setData(curCard, this.state.mode)

              if (!againNew && errorData.length <= 0) {
                this.props.setEditPromptvisible &&
                  this.props.setEditPromptvisible(false)
              } else {
                this.clearDialogData()
                this.setDialogData(
                  {
                    utility,
                    unit,
                    year,
                    eventIdx: '1',
                    eventNum: data[0].eventNum + 1,
                    againNew,
                  },
                  []
                )
              }
              if (againNew)
                this.updateCAllNextEventNumber({ utility, unit, year })
            }
          }
        )
      }
    }
  }

  saveByClient = (save, againNew = false) => {
    const { mode = 'N' } = this.props
    if (this.props.CLIENT === SRP_CLIENT && (mode === 'N' || mode === 'E')) {
      const { extensionData } = this.state
      if (
        !extensionData.string5 ||
        (extensionData.string5 || '').trim().length <= 0
      ) {
        Modal.confirm({
          width: '500px',
          title: 'System Code',
          content: (
            <div>
              <div>Warning: A System Code has not been selected.</div>
              <div>
                Please click OK to continue to save without a system code,
              </div>
              <div>or click Cancel to select one.</div>
            </div>
          ),
          onOk() {
            save({ againNew })
          },
          onCancel() {},
        })
      } else save({ againNew })
    } else if (
      this.props.CLIENT === BROOKFIELD_CLIENT &&
      (mode === 'N' || mode === 'E')
    ) {
      const { spillValidation = [] } = this.state
      const isValid =
        spillValidation.length <= 0 ||
        spillValidation.filter(f => !f.includes('WARNING')).length <= 0

      if (!isValid) {
        message.warning('Please, resolve all Spill Validation before Save')
      } else save({ againNew })
    } else save({ againNew })
  }

  handleChange = ({ name, value }, dataModified = true) => {
    let nv = value
    if (name === 'description') {
      nv = fixDescriptionValue(value)
    }
    this.setState({
      [name]: nv,
      dataModified,
    })
  }

  componentDidMount() {
    const {
      timeZoneMap,
      contribConditionList,
      contribConditionMap,
    } = this.props
    const {
      eventStart,
      eventEnd,
      workStart,
      workEnd,
      unit = this.props.criteriaUnit,
      year,
      utility,
      // eventNum,
    } = this.state

    // getContribCondtition(this.props.apiTargetInfo).fork(
    //   _ => _,
    //   data => {
    //     this.setState({
    //       contribConditionList: data,
    //       contribConditionMap: R.compose(
    //         R.fromPairs,
    //         R.map(({ code, description }) => [code, description])
    //       )(data),
    //     })
    //   }
    // )

    getCard97ExtensionSpec(this.props.apiTargetInfo).fork(
      this.props.setError,
      d => {
        if (d.length > 0) {
          this.setState({ extensionSpec: { ...d[0], avaliable: true } })
        }
      }
    )

    // if(CLIENT===CALPLINE_CLIENT){
    getSystemConfigurationInfo(this.props.apiTargetInfo).fork(
      _ => _,
      data => {
        let outageEventTypes =
          (data.find(k => k.key === 'OUTAGE_EVENT_TYPES') || { value: '' })
            .value || ''
        outageEventTypes = outageEventTypes.split(',')

        const isRequiredContribOperCond =
          ((
            data.find(k => k.key === 'CARD97_REQUIRED_ContOperCond') || {
              value: 'NO',
            }
          ).value || 'NO') === 'YES'

        this.setState({ outageEventTypes, isRequiredContribOperCond })
      }
    )
    // }

    this.retrieveDataCheck(utility, unit, year)

    this.setState({
      contribConditionList,
      contribConditionMap,
      eventStartZone:
        this.state.eventStartZone ||
        setDstZone(
          eventStart,
          this.state.eventStartZone,
          timeZoneMap,
          unit,
          this.props.units
        ),
      eventEndZone:
        this.state.eventEndZone ||
        setDstZone(
          eventEnd,
          this.state.eventEndZone,
          timeZoneMap,
          unit,
          this.props.units
        ),
      workStartZone:
        this.state.workStartZone ||
        setDstZone(
          workStart,
          this.state.workStartZone,
          timeZoneMap,
          unit,
          this.props.units
        ),
      workEndZone:
        this.state.workEndZone ||
        setDstZone(
          workEnd,
          this.state.workEndZone,
          timeZoneMap,
          unit,
          this.props.units
        ),
    })

    this.eventTypeRef &&
      this.eventTypeRef.current &&
      this.eventTypeRef.current.focus()
    const isCOPU = !!this.props.units.find(
      f =>
        f.emsId === 'CO-PU' &&
        f.unitId === (this.props.rowData.unit || this.props.unit)
    )

    this.setState({ isCOPU })
  }

  setDialogData = (data = {}, idxData) => {
    const causeCodeDF =
      getExpandedKeys(this.props.unitCodeCauseCodeMap || {})(
        this.props.unitCodeMap[data.unit],
        data.causeCode
      ) || {}
    const finalObj = {
      ...data,
      ...causeCodeDF,
      eventType: getDataEventType(data),
      idxData,
      extensionData: {
        year: data.year,
        unit:
          data.utility && data.unit && data.unit.length > 3
            ? data.unit.substring(data.utility.length)
            : data.unit,

        utility: data.utility,
        eventNum: data.eventNum,
        ...data.extension,
      },
    }

    this.setState(finalObj)
  }

  setTimeZone = (date, timeZoneOptMap) => {
    let daylightSavings =
      this.props.units.find(u => u.unitId === this.state.unit) || {}

    daylightSavings = daylightSavings.daylightSavings || 'N'
    // date.isDST false when calling secound time so nee to creat new moment
    return date && timeZoneOptMap.length > 0
      ? moment(
          moment(date).format('MM/DD/YYYY HH:mm'),
          'MM/DD/YYYY HH:mm'
        ).isDST() && daylightSavings === 'Y'
        ? (timeZoneOptMap[1] || {}).text || ''
        : timeZoneOptMap[0].text
      : ''
  }

  updateCAllNextEventNumber = ({ utility, unit, year }) => {
    const { apiTargetInfo, setError } = this.props
    getCard97NextEventNumber(apiTargetInfo)({
      year,
      unit: unit.substring(3),
      utility: utility.substring(0, 3),
    }).fork(setError, nmap => {
      this.clearDialogData()
      const nextEventNumber = nmap.NEXT_EVENT_NUMBER || '1'

      this.setDialogData(
        {
          ...this.props.rowData,
          utility,
          unit,
          year,
          eventIdx: '1',
          eventNum: nextEventNumber,
        },
        []
      )
    })
  }

  retrieveDataCheck = (utility, unit, year) => {
    const { mode, eventNum } = this.state
    const {
      apiTargetInfo,
      setError,
      setSpinning,
      CLIENT = 'INTEG',
    } = this.props
    if (
      utility === undefined ||
      unit === undefined ||
      utility == null ||
      unit == null
    )
      return

    const enumber = mode === 'V' || mode === 'D' ? eventNum : undefined
    setSpinning(true)
    getDataCheckServiceByclient(CLIENT)(apiTargetInfo)({
      year,
      units: [unit],
      eventnum: enumber,
    }).fork(setError, dataUnsort => {
      setSpinning(false)
      let clientData = dataUnsort
      if (CLIENT === BROOKFIELD_CLIENT && mode !== 'N') {
        const modifySpillData = spillData =>
          spillData.map(d => {
            const spillStartMod =
              d.spillStart && this.state.eventStartZone
                ? moment
                    .utc(d.spillStart)
                    // .utc()
                    .tz(timeZoneIdentMap[this.state.eventStartZone])
                    .format('MM/DD/YYYY HH:mm')
                : // || moment(this.state.eventStart).format('MM/DD/YYYY HH:mm')
                  undefined
            const spillEndMod =
              d.spillEnd && this.state.eventStartZone
                ? moment
                    .utc(d.spillEnd)
                    // .utc()
                    .tz(timeZoneIdentMap[this.state.eventStartZone])
                    .format('MM/DD/YYYY HH:mm')
                : // ||   moment(this.state.eventEnd).format('MM/DD/YYYY HH:mm')
                  undefined

            return {
              ...d,
              spillStartMod,
              spillEndMod,
              // durHr,
              overwriteFactor: d.overwriteFactor || d.defaultFactor,
            }
          })
        clientData = clientData.map(d => ({
          ...d,
          extension: {
            ...d.extension,
            spillData: modifySpillData(d.extension.spillData || []),
          },
        }))
      }

      let data = this.props.modifyClientDataafterRetrieve
        ? this.props.modifyClientDataafterRetrieve({
            data: clientData,
            mode,
          })
        : clientData
      data = R.sort((a, b) => a.eventIdx - b.eventIdx, data)

      const pageOptions = data
        .filter(d => d.eventIdx === 1 || d.eventIdx === '1')
        .map(d => parseInt(d.eventNum))
        .sort((a, b) => a - b)
      this.handleChange(
        {
          name: 'retData',
          value: data.filter(d => d.eventIdx === 1 || d.eventIdx === '1'),
        },
        false
      )
      this.handleChange(
        {
          name: 'retDataIdx',
          value: data.filter(d => d.eventIdx !== 1 || d.eventIdx !== '1'),
        },
        false
      )
      // handleChange({ name: 'idxData', value: data.filter(d => d.eventIdx != 1 && ) })
      this.handleChange({ name: 'pageOptions', value: pageOptions }, false)

      this.setPageOptions(pageOptions)

      // }

      if (mode === 'N') {
        this.updateCAllNextEventNumber({ utility, unit, year })
      }

      if (mode === 'E' || mode === 'D' || mode === 'V') {
        const en = pageOptions.findIndex(
          d => d === eventNum || eventNum === d + ''
        )
        let minEvnNum = eventNum
        if (en === -1) {
          minEvnNum =
            Math.min(...(data || []).map(d => parseInt(d.eventNum))) + ''
          if (minEvnNum === Infinity) minEvnNum = eventNum
        }
        const dt =
          en < 0
            ? data.find(
                d =>
                  d.eventNum === minEvnNum &&
                  (d.eventIdx === 1 || d.eventIdx === '1')
              ) || data[0]
            : data.find(
                d =>
                  d.eventNum === minEvnNum &&
                  (d.eventIdx === 1 || d.eventIdx === '1')
              )
        if (dt) {
          this.clearDialogData()
          this.setDialogData(
            dt,
            data
              .filter(d => d.eventIdx !== '1')
              .filter(c => c.eventNum === minEvnNum)
              .sort((a, b) => a.eventIdx - b.eventIdx)
          )
        } else {
          // this is new
          // const maxNumber= R.reduce(R.maxBy(x=>x),   data.map(d=> parseInt(d.eventNum)))
          this.clearDialogData()
          this.setDialogData(
            { utility, unit, year, eventNum: '0', eventIdx: '1' },
            []
          )
        }

        setTimeout(_ => {
          const timeZoneOptionMap = this.timeZoneOption(this.props.timeZoneMap)

          const eventStartZone =
            this.state.eventStartZone ||
            this.setTimeZone(this.state.eventStart, timeZoneOptionMap)
          const eventEndZone =
            this.state.eventEndZone ||
            this.setTimeZone(this.state.eventEnd, timeZoneOptionMap) ||
            ''
          const workStartZone =
            this.state.workStartZone ||
            this.setTimeZone(this.state.workStart, timeZoneOptionMap) ||
            ''
          const workEndZone =
            this.state.workEndZone ||
            this.setTimeZone(this.state.workEnd, timeZoneOptionMap) ||
            ''

          this.handleChange(
            {
              name: 'eventStartZone',
              value: eventStartZone,
            },
            false
          )
          this.handleChange(
            { name: 'eventEndZone', value: eventEndZone },
            false
          )
          this.handleChange(
            {
              name: 'workStartZone',
              value: workStartZone,
            },
            false
          )
          this.handleChange({ name: 'workEndZone', value: workEndZone }, false)
          this.props.extraHanleChageOnDatacheck &&
            this.props.extraHanleChageOnDatacheck({
              handleChange: this.handleChange,
              data,
            })
        }, 200)
      }
    })
  }

  clearDialogData = _ => {
    // utility field is not required so add utility
    const { utility } = this.state
    const ndata = this.props.headers
      .filter(c => !c.isKey)
      .map(c => c.ident)
      .map(a => ({ [a]: null }))
      .reduce((a, b) => ({ ...a, ...b }))
    this.setDialogData({ ...ndata, utility, eventType: null }, [])
  }

  timeZoneOpt = R.compose(
    R.map(([_, text]) => ({ key: text, text, value: text })),
    R.sortBy(([_, text]) => text.toLowerCase()),
    R.filter(([key, _]) => key === this.state.unit),
    R.toPairs
  )

  timeZoneOption = tList => {
    // daylightSavings = 'Y' 'N'

    let daylightSavings =
      this.props.units.find(u => u.unitId === this.state.unit) || {}

    daylightSavings = daylightSavings.daylightSavings || 'N'

    const list = this.timeZoneOpt(tList)
    if (list.length === 1 && daylightSavings !== 'N') {
      const zone = `${list[0].text.substring(0, 1)}D${list[0].text.substring(
        2,
        3
      )}`
      list.push({ key: zone, text: zone, value: zone })
    }
    return list
  }

  render() {
    const {
      // eslint-disable-next-line no-unused-vars
      CLIENT = 'INTEG',
      mode = 'N',
      // utilityNameMap,
      // unitNameMap,
      timeZoneMap,
      // card97Dominant,
      // unitsList,
      ampCodeMap,
      failCodeMap,
      causeCodeMap,
      // setMode,
      // apiTargetInfo,
      // headers,
      // utilityUnitMap,
    } = this.props
    const {
      utility,
      unit,
      year,
      eventNum,
      eventType,
      outageEventTypes = [],
      availCap,
      causeCode,
      failCode,
      ampCode,
      conCode,
      // ioCode,
      manHour,
      description,
      eventStart,
      eventEnd,
      workStart,
      workEnd,
      lock,
      msg,
      // loading,
      errors,
      onlyWarning,
      errorPrompt,
      failCodeDialog,
      tableFailCodeDialog,
      idxData = this.props.idxData,
      causeCodeDialog,
      // tableCauseCodeDialog,
      lowerTableDialog,
      // tab = 'main',
      // eslint-disable-next-line no-unused-vars
      contribConditionList = [],
      extensionData = {},
      isRequiredContribOperCond,
    } = this.state

    const timeZoneOptionMap = this.timeZoneOption(timeZoneMap)

    const setDataOnEventType = value => {
      if (['D1', 'D2', 'D3', 'D4', 'PD', 'DM', 'DP', 'DE'].includes(value)) {
        this.setState({
          eventType: value,
          ioCode: '0',
          availCap: availCap === '0' ? '' : availCap,
          causeCode: ['0', '2', '9991', '9990'].includes(causeCode)
            ? ''
            : causeCode,
          causeCodeDescription: ['0', '2', '9991', '9990'].includes(causeCode)
            ? ''
            : this.state.causeCodeDescription,
          description: [
            'Reserve Shutdown',
            'Inactive Reserve',
            'Mothballed',
            'Retired',
          ].includes(description)
            ? ''
            : description,
        })
      } else if (
        ['SF', 'U1', 'U2', 'U3', 'MO', 'PO', 'SE', 'ME', 'PE'].includes(value)
      ) {
        this.setState({
          eventType: value,
          ioCode: '0',
          availCap: '0',
          causeCode: ['0', '2', '9991', '9990'].includes(causeCode)
            ? ''
            : causeCode,
          causeCodeDescription: ['0', '2', '9991', '9990'].includes(causeCode)
            ? ''
            : this.state.causeCodeDescription,
          description: [
            'Reserve Shutdown',
            'Inactive Reserve',
            'Mothballed',
            'Retired',
          ].includes(description)
            ? ''
            : description,
        })
      } else if (['RS', 'IR', 'MB', 'RU'].includes(value)) {
        this.setState({
          eventType: value,
          ioCode: '0',
          description:
            value === 'RS'
              ? 'Reserve Shutdown'
              : value === 'IR'
              ? 'Inactive Reserve'
              : value === 'MB'
              ? 'Mothballed'
              : value === 'RU'
              ? 'Retired'
              : description,
          availCap: ['RS', 'IR', 'MB', 'RU'].includes(value) ? '0' : availCap,
          causeCode:
            value === 'RS'
              ? '0'
              : value === 'IR'
              ? '2'
              : value === 'MB'
              ? '9991'
              : value === 'RU'
              ? '9990'
              : causeCode,
          causeCodeDescription:
            value === 'RS'
              ? 'Reserve Shutdown'
              : value === 'IR'
              ? 'Inactive Reserve'
              : value === 'MB'
              ? 'Mothballed Unit'
              : value === 'RU'
              ? 'Retired Unit'
              : this.state.causeCodeDescription,
          failCode: value === 'RS' ? '' : failCode,
          ampCode: value === 'RS' ? '' : ampCode,
        })
      } else if (['CO', 'PU'].includes(value)) {
        this.setState({
          eventType: value,
          causeCode: value === 'CO' ? '9340' : '9345',
          description: '',
        })
      } else {
        this.setState({
          eventType: value,
          ioCode: '0',
          causeCode: ['0', '2', '9991', '9990'].includes(causeCode)
            ? ''
            : causeCode,
          causeCodeDescription: ['0', '2', '9991', '9990'].includes(causeCode)
            ? ''
            : this.state.causeCodeDescription,
          description: [
            'Reserve Shutdown',
            'Inactive Reserve',
            'Mothballed',
            'Retired',
          ].includes(description)
            ? ''
            : description,
        })
      }
      this.setState({ dataModified: true })
    }

    const onCell = _ => ({
      style: { paddingTop: '10px', paddingBottom: '10px' },
    })

    const columns = [
      // {
      //   title: 'Idx',
      //   dataIndex: 'eventIdx',
      //   width: '40px',
      // },
      {
        title: 'Cause Code',
        dataIndex: 'causeCode',
        onCell,
        width: '70px',
      },
      {
        title: 'Cause Code Desc.',
        dataIndex: 'causeCodeDesc',
        render: (text, record) =>
          (record.causeCode && causeCodeMap[record.causeCode]) || '',
        onCell,
        width: 250,
      },
      {
        title: 'Cont. Code',
        dataIndex: 'conCode',
        onCell,
        width: '70px',
      },
      {
        title: 'Con. Oper. Cond.',
        dataIndex: 'eventTypeExternal',
        render: (text, record) => {
          if (
            ((record.extension || {}).eventTypeExternal || '').trim().length > 0
          ) {
            return (
              record.extension.eventTypeExternal +
              ' - ' +
              (this.state.contribConditionMap || {})[
                record.extension.eventTypeExternal
              ]
            )
          } else return record?.extension?.eventTypeExternal
        },
        onCell,
        width: 150,
      },
      {
        title: 'Fail Code',
        dataIndex: 'failCode',
        onCell,
        width: '70px',
      },
      {
        title: 'Ampl. Code',
        dataIndex: 'ampCode',
        onCell,
        width: '120px',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        onCell,
      },
      {
        title: '',
        dataIndex: 'deleteCauseCode',
        onCell,
      },
      {
        width: '90px',
        title: 'Action',
        key: 'action',
        render: (text, record, index) =>
          mode === 'D' || mode === 'V' ? (
            ''
          ) : this.isAdmin === false && lock === 'C' ? (
            ``
          ) : (
            <span>
              <Icon
                type="edit"
                theme="twoTone"
                onClick={() => this.openLowerTablePrompt(true, index, 'edit')}
              />
              <Divider type="vertical" />
              <Popconfirm
                title="Are you sure to delete this record?"
                onConfirm={() => {
                  this.setState({
                    idxData: idxData.filter((d, i) => i !== index),
                  })
                }}
                onCancel={_ => _}
                okText="Yes"
                cancelText="No"
              >
                <Icon type="delete" theme="twoTone" />
              </Popconfirm>
            </span>
          ),
      },
    ]

    const changeEventNumber = value => {
      this.handleChange({ value, name: 'eventNum' }, false)
      const { retData = [], retDataIdx = [] } = this.state
      const data = retData.find(
        d => d.eventNum === value || d.eventNum === value + ''
      )

      if (data && (mode === 'E' || mode === 'D')) {
        // setMode('Edit Data')
        this.setState({
          ...data,
          idxData: retDataIdx.filter(
            c => c.eventNum === value || c.eventNum === value + ''
          ),
          extensionData: data.extension,
        })
      }
      // khan d0 not want to clear data
      // else {
      //   this.clearDialogData()
      // }
    }

    const getTitle = eventNum => {
      const d = this.state.retData.find(
        d => d.eventNum === eventNum || d.eventNum === eventNum + ''
      )
      return d ? d.eventNum : ''
    }

    const getCurrentPage = _ => {
      let curPage = this.state.pageOptions.findIndex(
        c => c === this.state.eventNum || this.state.eventNum === c + ''
      )

      if (curPage < 0) curPage = 0
      // else {
      //   this.state.pageOptions.findIndex(
      //     c => c === this.state.eventNum || this.state.eventNum === c + ''
      //   )
      // }
      return curPage
    }

    const pageChange = (curPage, pageSize, showDataModifiedMessaage = true) => {
      // == compare String vs num
      // const { eventNum, pageOptions } = this.state
      // && eventNum !== pageOptions[curPage] + ''
      if (showDataModifiedMessaage) {
        if (this.state.dataModified) {
          message.error(
            'Data Modified, Please Save or Clear Modification for further process'
          )
          return
        }
      }

      this.clearDialogData()
      const data = this.state.retData.find(
        d =>
          d.eventNum === this.state.pageOptions[curPage - 1] ||
          d.eventNum === this.state.pageOptions[curPage - 1] + ''
      )
      const idxData = this.state.retDataIdx.filter(
        pg =>
          (pg.eventNum === curPage || pg.eventNum === curPage + '') &&
          pg.eventIdx !== '1'
      )
      // this.setState({ dataModified: false })
      this.setDialogData({ ...data, dataModified: false }, idxData)
    }

    const clearData = _ => {
      if (mode === 'N') {
        this.setState({ dataModified: false })
        this.clearDialogData()
      } else {
        pageChange(getCurrentPage() + 1, null, false)
      }
    }

    const InsHeader = (
      <React.Fragment>
        <HeaderTag
          style={{
            verticalAlign: 'middle',
            alignSelf: 'center',
            // gridRowEnd: 'span 3',
            textAlign: 'center',
            color: 'darkblue',
          }}
        >
          {mode === 'E' ? (
            <span>
              {this.state.lock === 'L' && !this.isAdmin && <Icon type="lock" />}
              {'  '}Edit Data
            </span>
          ) : mode === 'D' ? (
            'Delete Data'
          ) : mode === 'N' ? (
            'New Data'
          ) : (
            'View Data'
          )}
        </HeaderTag>
        <div
          style={{
            backgroundColor: '#e6f7ff',
            display: 'grid',
            gridTemplateColumns: '2fr 12fr 2fr 5fr',
            gridColumnGap: '15px',
            padding: '0px 5px 10px',
            justifyContent: 'space-around',
            gridRowGap: '10px',
          }}
        >
          <Label style={{ padding: '10px 0px 0px', gridColumnEnd: 'span 2' }}>
            Utility / Unit
          </Label>
          <Label style={{ padding: '10px 0px 0px', gridColumnEnd: 'span 2' }}>
            Year
          </Label>
          {/* {mode.toLowerCase().indexOf('edit') >= 0 && (
          <Label style={{ marginLeft: '10px', gridColumnEnd: 'span 2' }}>Events</Label>
        )} */}

          <UtilityUnitSelection
            style={{ gridColumnEnd: 'span 2' }}
            utility={utility}
            unit={unit}
            defaultValue={
              [utility, unit]
              // mode.toLowerCase().indexOf('edit') >= 0 ? [utility, unit] : []
              // : selectedUnits.lenght > 1
              // ? []
              // : [selectedUnits[0].utility, selectedUnits[0].unitId]
            }
            onUnitChange={value => {
              this.handleChange({ name: 'utility', value: value[0] })
              this.handleChange({ name: 'unit', value: value[1] })
              let isCOPU =
                this.props.units.find(f => f.unitId === value[1]) || false
              isCOPU = isCOPU ? isCOPU.emsId === 'CO-PU' : false

              // this.handleChange({ name: 'isCOPU', value: emsId })
              this.setState({ isCOPU })

              this.retrieveDataCheck(value[0], value[1], year)
            }}
            disabled={
              mode === 'D' ||
              mode === 'V' ||
              mode === 'E' ||
              (this.state.dataModified &&
                utility !== undefined &&
                unit !== undefined &&
                utility != null &&
                unit != null)
            }
          />
          <Select
            style={{ alignSelf: 'center', gridColumnEnd: 'span 2' }}
            value={year}
            // defaultValue={year}
            onChange={year => {
              this.handleChange({ name: 'year', value: year })
              this.retrieveDataCheck(utility, unit, year)
            }}
            disabled={
              mode === 'D' ||
              mode === 'V' ||
              mode === 'E' ||
              (this.state.dataModified &&
                utility !== undefined &&
                unit !== undefined &&
                utility != null &&
                unit != null)
            }
          >
            {yearOption}
          </Select>
        </div>
      </React.Fragment>
    )

    // id=f admin then no lock needed
    // when lock = 'C'  then only EndDate is editalbe
    // when lock = 'L' then all diabled
    // when lock =='U' || lock = 'R' means unlock

    const disableSaveButton = _ => {
      const fv = !(
        this.state.retData &&
        this.state.retData.find(
          ev =>
            ev.eventNum === this.state.eventNum ||
            ev.eventNum === this.state.eventNum + ''
        ) === undefined
      )
      if (mode === 'D') return false
      else if (mode === 'N') {
        return fv
      } else if (mode === 'E' && this.state.lock === 'L') {
        return !(this.isAdmin && true)
      } else if (mode === 'E') {
        return !fv
      }
    }

    const disableComp =
      this.isAdmin && (mode === 'E' || mode === 'N')
        ? false
        : lock === 'C' || lock === 'L' || mode === 'D' || mode === 'V'

    const disableDescription =
      mode === 'D' && CLIENT === DOM_CLIENT
        ? false
        : this.isAdmin && (mode === 'E' || mode === 'N')
        ? false
        : lock === 'C' || lock === 'L' || mode === 'D' || mode === 'V'

    const disableEndDate =
      this.isAdmin && (mode === 'E' || mode === 'N')
        ? false
        : mode === 'D' || mode === 'V' || lock === 'L'

    const disableFailAmpCode =
      this.isAdmin &&
      (mode === 'E' || mode === 'N') &&
      eventType &&
      eventType !== 'RS'
        ? false
        : lock === 'C' ||
          lock === 'L' ||
          (eventType && eventType === 'RS') ||
          mode === 'D' ||
          mode === 'V'

    const disableDominant =
      this.isAdmin &&
      (mode === 'E' || mode === 'N') &&
      ['D1', 'D2', 'D3', 'D4', 'PD'].includes(eventType)
        ? false
        : mode === 'D' ||
          lock === 'C' ||
          lock === 'L' ||
          mode === 'V' ||
          !['D1', 'D2', 'D3', 'D4', 'PD'].includes(eventType)

    const disableCOPUEVentTypeView = eventType === 'CO' || eventType === 'PU'

    const dateFormatInfoDialog = _ => {
      Modal.info({
        title: 'Date format Information',
        content: (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '20% 10% 70%',
              width: '200px',
              gridRowGap: '5px',
            }}
          >
            <div style={{ gridColumnEnd: 'span 3' }}>
              <b>
                <u>MM/dd/yyyy HH:mm:ss</u>
              </b>
            </div>
            <div>MM</div>
            <div>-</div>
            <div>Month</div>
            <div>dd</div>
            <div>-</div>
            <div>Date</div>
            <div>yyyy</div>
            <div>-</div>
            <div>Year</div>
            <div>HH</div>
            <div>-</div>
            <div>Hour (24 base)</div>
            <div>mm</div>
            <div>-</div>
            <div>Minute </div>
            <div>ss</div>
            <div>-</div>
            <div>Secound</div>
          </div>
        ),
      })
    }

    return (
      <div>
        <Modal
          // title={mode !== 'new' ? headerDiv : <InsertHeader />}
          destroyOnClose
          title={InsHeader}
          visible={this.props.promptEdit}
          onCancel={_ => {
            // this.props.retrieveData({})
            this.props.setEditPromptvisible(false)
          }}
          key="card97"
          footer={
            <React.Fragment>
              {mode !== 'V' && (
                <Button
                  type="primary"
                  disabled={disableSaveButton()}
                  onClick={
                    this.props.save || (_ => this.saveByClient(this.save))
                  }
                  key="savebtn"
                  loading={this.props.spinning}
                >
                  {mode === 'D'
                    ? 'Delete'
                    : mode === 'E'
                    ? 'Save'
                    : mode === 'N'
                    ? 'Insert'
                    : 'OK'}
                </Button>
              )}
              {mode === 'N' && (
                <Button
                  type="primary"
                  key="insert-new"
                  disabled={disableSaveButton()}
                  onClick={
                    this.props.save || (_ => this.saveByClient(this.save, true))
                  }
                  loading={this.props.spinning}
                >
                  Insert & New
                </Button>
              )}
              {(mode === 'N' || this.state.dataModified) && (
                <Button
                  type="dashed"
                  onClick={clearData}
                  disabled={
                    // mode !== 'N' &&
                    // disableSaveButton() &&
                    !this.state.dataModified
                    // && utility !== undefined &&
                    // unit !== undefined &&
                    // utility != null &&
                    // unit != null
                  }
                  loading={this.props.spinning}
                >
                  Clear Modification
                </Button>
              )}

              <Button
                onClick={() => {
                  // this.props.retrieveData({})
                  this.props.setEditPromptvisible &&
                    this.props.setEditPromptvisible(false)
                }}
                loading={this.props.spinning}
                key="cancelbtn"
              >
                Cancel
              </Button>
            </React.Fragment>
          }
          centered
          width={1100}
          height="100%"
          bodyStyle={{
            padding: '20px',
            paddingTop: '2px',
            paddingBottom: '2px',
            minHeight: '500px',
          }}
          style={{ top: 10 }}
          maskStyle={{ height: '100%' }}
          maskClosable={false}
        >
          <Spin spinning={this.props.spinning} style={{ order: 2 }}>
            <Tabs
              type="card"
              activeKey={this.state.tab}
              defaultActiveKey="main"
              onChange={key => this.setState({ tab: key })}
              tabBarExtraContent={[
                mode === 'N' &&
                  this.state.retData &&
                  this.state.retData.find(
                    ev =>
                      ev.eventNum === this.state.eventNum ||
                      ev.eventNum === this.state.eventNum + '' ||
                      ev.eventNum + '' === this.state.eventNum
                  ) !== undefined && (
                    <h3 style={{ textAlign: 'left', color: 'red' }}>
                      Event Number : {this.state.eventNum} already exists
                    </h3>
                  ),
                mode === 'E' && this.state.retData && (
                  <div style={{ display: 'inline-flex' }}>
                    <div style={{ fontWeight: '500', marginRight: '10px' }}>
                      Events :
                    </div>
                    <Pagination
                      disabled={this.state.pageOptions.length <= 0}
                      style={{ alignSelf: 'center' }}
                      // pageSizeOptions={}
                      // pageSizeOptions={['10', '11', '12', '13', '17']}
                      pageSize={1}
                      showTitle={false}
                      total={this.state.pageOptions.length}
                      showQuickJumper
                      onChange={curPage => pageChange(curPage)}
                      current={getCurrentPage() + 1}
                      itemRender={(current, type, originalElement) => {
                        if (
                          type === 'page' &&
                          this.state.pageOptions.length > 0
                        ) {
                          return (
                            <a
                              title={getTitle(
                                this.state.pageOptions[current - 1]
                              )}
                            >
                              {this.state.pageOptions[current - 1]}
                            </a>
                          )
                        } else return originalElement
                      }}
                    />
                  </div>
                ),
                <div style={{ width: '200px' }} key="ddd" />,
              ]}
              style={{ height: 'inherit' }}
            >
              <Tabs.TabPane key="main" tab="Main" forceRender>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridColumnGap: '30px',
                  }}
                >
                  <SubDiv>
                    <Labeled>{'Event Number: '}</Labeled>

                    <InputNumber
                      style={{ width: '100%' }}
                      key="eventNum"
                      value={eventNum}
                      placeholder="Event Number"
                      name="eventNum"
                      max={9999}
                      min={1}
                      // label="(Optional)"
                      // labelPosition="right"
                      onChange={value => changeEventNumber(value)}
                      disabled={mode !== 'N'}
                    />
                  </SubDiv>
                  <div
                    style={{
                      gridRowEnd: 'span 5',
                      gridColumnEnd: 'span 2',
                      border: '1px solid lightgrey',
                      padding: '2px 10px 10px',
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gridColumnGap: '30px',
                      // gridTemplateRows: 'auto auto 30px auto 50px auto 30px auto',
                      // alignContent: 'flex-start',
                    }}
                  >
                    <Labeled
                      style={{
                        gridColumnEnd: 'span 1',
                      }}
                    >
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '5px max-content 30px',
                        }}
                      >
                        <span
                          style={{
                            color: 'red',
                            display: 'grid',
                            alignContent: 'end',
                          }}
                        >
                          *
                        </span>
                        <div
                          style={{
                            marginLeft: '5px',
                            marginRight: '5px',
                            display: 'grid',
                            alignContent: 'end',
                          }}
                        >
                          Event Start: (MM/dd/yyyy HH:mm)
                        </div>

                        <Button
                          onClick={dateFormatInfoDialog}
                          icon="info-circle"
                          style={{ marginLeft: '5px', marginRight: '10px' }}
                        />
                      </div>
                    </Labeled>
                    <div />
                    <DatePicker
                      style={{}}
                      id="eventStart"
                      disabled={disableComp}
                      // showTime
                      // defaultValue={moment(eventStart).format('MM/DD/YYYY HH:mm') || ''}
                      value={
                        eventStart &&
                        moment(
                          moment(eventStart).format('MM/DD/YYYY HH:mm'),
                          'MM/DD/YYYY HH:mm'
                        )
                      }
                      showTime={{
                        format: 'h:mm',
                        defaultValue: moment('00:00', 'HH:mm'),
                      }}
                      format="MM/DD/YYYY HH:mm"
                      placeholder="Select DateTime"
                      onChange={date => {
                        this.handleChange({ name: 'eventStart', value: date })
                        this.handleChange({
                          name: 'eventStartZone',
                          value: this.setTimeZone(date, timeZoneOptionMap),
                        })
                        //   this.setState({
                        //   eventStart: date,
                        //   eventStartZone: setTimeZone(date, timeZoneOptionMap),
                        // })
                      }}
                      onOk={date => {
                        this.handleChange({ name: 'eventStart', value: date })
                        this.handleChange({
                          name: 'eventStartZone',
                          value: this.setTimeZone(date, timeZoneOptionMap),
                        })
                        // this.setState({
                        //   eventStart: date,
                        //   eventStartZone: this.setTimeZone(
                        //     date,
                        //     timeZoneOptionMap
                        //   ),
                        // })
                      }}
                    />
                    <Select
                      style={{ marginLeft: '5px' }}
                      key="eventStartZone"
                      disabled={disableComp}
                      value={
                        (this.state.eventStartZone
                          ? this.state.eventStartZone
                          : this.setTimeZone(eventStart, timeZoneOptionMap)) ||
                        ''
                      }
                      placeholder="TimeZone"
                      name="eventStartZone"
                      onChange={value =>
                        this.handleChange({ name: 'eventStartZone', value })
                      }
                      selection
                      options={timeZoneOptionMap}
                    >
                      {timeZoneOptionMap.map(e => (
                        <Select.Option key={e.value} value={e.value}>
                          {e.text}
                        </Select.Option>
                      ))}
                    </Select>

                    <Labeled
                      style={{ gridColumnEnd: 'span 2', alignSelf: 'end' }}
                    >
                      Event End: (MM/dd/yyyy HH:mm)
                    </Labeled>
                    <DatePicker
                      style={{}}
                      id="eventEnd"
                      value={
                        eventEnd &&
                        moment(
                          moment(eventEnd).format('MM/DD/YYYY HH:mm'),
                          'MM/DD/YYYY HH:mm'
                        )
                      }
                      showTime={{
                        format: 'h:mm',
                        defaultValue: moment('00:00', 'HH:mm'),
                      }}
                      format="MM/DD/YYYY HH:mm"
                      placeholder="Select DateTime"
                      onChange={date => {
                        this.handleChange({
                          name: 'eventEnd',
                          value: moment(
                            moment(date).format('MM/DD/YYYY HH:mm'),
                            'MM/DD/YYYY HH:mm'
                          ),
                        })
                        this.handleChange({
                          name: 'eventEndZone',
                          value: this.setTimeZone(date, timeZoneOptionMap),
                        })
                        //   this.setState({
                        //     eventEnd: date,
                        //     eventEndZone: this.setTimeZone(
                        //       date,
                        //       timeZoneOptionMap
                        //     ),
                        //   })
                        // }
                      }}
                      disabled={disableEndDate}
                    />
                    <Select
                      style={{ marginLeft: '5px' }}
                      key="eventEndZone"
                      value={
                        (this.state.eventEndZone
                          ? this.state.eventEndZone
                          : this.setTimeZone(eventEnd, timeZoneOptionMap)) || ''
                      }
                      placeholder="TimeZone"
                      name="eventEndZone"
                      onChange={value =>
                        this.handleChange({ name: 'eventEndZone', value })
                      }
                      selection
                      options={timeZoneOptionMap}
                      disabled={disableEndDate}
                    >
                      {timeZoneOptionMap.map(e => (
                        <Select.Option key={e.value} value={e.value}>
                          {e.text}
                        </Select.Option>
                      ))}
                    </Select>
                    {!this.showWorkDates && (
                      <React.Fragment>
                        <div style={{ gridRowEnd: 'span 12' }} />
                      </React.Fragment>
                    )}
                    {this.showWorkDates && (
                      <React.Fragment>
                        <Labeled
                          style={{ gridColumnEnd: 'span 2', alignSelf: 'end' }}
                        >
                          Work Start: (MM/dd/yyyy HH:mm)
                        </Labeled>
                        <DatePicker
                          style={{}}
                          disabled={disableComp || disableCOPUEVentTypeView}
                          value={
                            workStart &&
                            moment(
                              moment(workStart).format('MM/DD/YYYY HH:mm'),
                              'MM/DD/YYYY HH:mm'
                            )
                          }
                          showTime={{
                            format: 'h:mm',
                            defaultValue: moment('00:00', 'HH:mm'),
                          }}
                          format="MM/DD/YYYY HH:mm"
                          placeholder="Select DateTime"
                          onChange={date => {
                            this.handleChange({
                              name: 'workStart',
                              value: date,
                            })
                            this.handleChange({
                              name: 'workStartZone',
                              value: this.setTimeZone(date, timeZoneOptionMap),
                            })
                            // this.setState({
                            //   workStart: date,
                            //   workStartZone: setTimeZone(date, timeZoneOptionMap),
                            // })
                          }}
                          onOk={date => {
                            this.handleChange({
                              name: 'workStart',
                              value: date,
                            })
                            this.handleChange({
                              name: 'workStartZone',
                              value: this.setTimeZone(date, timeZoneOptionMap),
                            })
                            // this.setState({
                            //   workStart: date,
                            //   workStartZone: this.setTimeZone(
                            //     date,
                            //     timeZoneOptionMap
                            //   ),
                            // })
                          }}
                        />
                        <Select
                          style={{ marginLeft: '5px' }}
                          key="workStartZone"
                          disabled={disableComp || disableCOPUEVentTypeView}
                          value={
                            (this.state.workStartZone
                              ? this.state.workStartZone
                              : this.setTimeZone(
                                  workStart,
                                  timeZoneOptionMap
                                )) || ''
                          }
                          placeholder="TimeZone"
                          name="workStartZone"
                          onChange={value =>
                            this.handleChange({ name: 'workStartZone', value })
                          }
                          selection
                          options={timeZoneOptionMap}
                        >
                          {timeZoneOptionMap.map(e => (
                            <Select.Option key={e.value} value={e.value}>
                              {e.text}
                            </Select.Option>
                          ))}
                        </Select>
                        <Labeled
                          style={{ gridColumnEnd: 'span 2', alignSelf: 'end' }}
                        >
                          Work End: (MM/dd/yyyy HH:mm)
                        </Labeled>
                        <DatePicker
                          style={{}}
                          disabled={disableComp || disableCOPUEVentTypeView}
                          value={
                            workEnd &&
                            moment(
                              moment(workEnd).format('MM/DD/YYYY HH:mm'),
                              'MM/DD/YYYY HH:mm'
                            )
                          }
                          showTime={{
                            format: 'h:mm',
                            defaultValue: moment('00:00', 'HH:mm'),
                          }}
                          format="MM/DD/YYYY HH:mm"
                          placeholder="Select DateTime"
                          onChange={date => {
                            this.handleChange({ name: 'workEnd', value: date })
                            this.handleChange({
                              name: 'workEndZone',
                              value: this.setTimeZone(date, timeZoneOptionMap),
                            })
                            // this.setState({
                            //   workEnd: date,
                            //   workEndZone: this.setTimeZone(
                            //     date,
                            //     timeZoneOptionMap
                            //   ),
                            // })
                          }}
                          onOk={date => {
                            this.handleChange({ name: 'workEnd', value: date })
                            this.handleChange({
                              name: 'workEndZone',
                              value: this.setTimeZone(date, timeZoneOptionMap),
                            })

                            // this.setState({
                            //   workEnd: date,
                            //   workEndZone: setTimeZone(date, timeZoneOptionMap),
                            // })
                          }}
                        />
                        <Select
                          style={{ marginLeft: '5px' }}
                          key="workEndZone"
                          disabled={disableComp || disableCOPUEVentTypeView}
                          value={
                            (this.state.workEndZone
                              ? this.state.workEndZone
                              : this.setTimeZone(workEnd, timeZoneOptionMap)) ||
                            ''
                          }
                          placeholder="TimeZone"
                          name="workEndZone"
                          onChange={value =>
                            this.handleChange({ name: 'workEndZone', value })
                          }
                          selection
                          options={timeZoneOptionMap}
                        >
                          {timeZoneOptionMap.map(e => (
                            <Select.Option key="workendzone" value={e.value}>
                              {e.text}
                            </Select.Option>
                          ))}
                        </Select>
                      </React.Fragment>
                    )}
                  </div>

                  <SubDiv>
                    <Labeled>
                      <span style={{ color: 'red' }}>*</span>
                      {' Event Type: '}
                    </Labeled>

                    <Select
                      showSearch
                      ref={this.eventTypeRef}
                      refs={this.eventTypeRef}
                      style={{ width: '100%' }}
                      key="eventType"
                      value={eventType || ''}
                      id="eType"
                      placeholder="Event Type"
                      disabled={disableComp}
                      name="eventType"
                      // onChange={this.handleChange}
                      onChange={value => {
                        setDataOnEventType(value)
                        if (CLIENT === CALPLINE_CLIENT) {
                          if (outageEventTypes.includes(value)) {
                            this.handleExtensionData('number1', '0')
                          }
                        }
                      }}
                      selection
                      // options={eventTypes}
                    >
                      {(this.props.eventTypes || []).map(e => (
                        <Select.Option value={e.eventType} key="eventtype">
                          {e.eventType}-{e.description}
                        </Select.Option>
                      ))}
                      {this.state.isCOPU && [
                        <Select.Option value="CO" key="CO">
                          CO-Condensing
                        </Select.Option>,
                        <Select.Option value="PU" key="PU">
                          PU-Pumping
                        </Select.Option>,
                      ]}
                    </Select>
                  </SubDiv>
                  {CLIENT === CALPLINE_CLIENT && (
                    <SubDiv style={{ gridColumnEnd: 'span 1' }}>
                      <Labeled>Gross Available Capacity (MW) :</Labeled>
                      <Input
                        style={{ width: '100%' }}
                        value={this.state.extensionData.number1}
                        // onChange={value => handleExtSave('number1', value)}
                        disabled={disableComp}
                        onChange={e => {
                          if (outageEventTypes.includes(eventType)) {
                            this.handleExtensionData('number1', 0)
                          } else {
                            if (!isNaN(e.target.value))
                              this.handleExtensionData(
                                'number1',
                                e.target.value
                              )
                          }
                        }}
                      />
                    </SubDiv>
                  )}
                  <SubDiv>
                    <Labeled>{'Net Available Cap: '}</Labeled>
                    <Input
                      style={{ width: '100%' }}
                      key="availCap"
                      // type="number"
                      disabled={disableComp || disableCOPUEVentTypeView}
                      value={availCap || ''}
                      placeholder="Net Available Cap"
                      name="availCap"
                      onChange={e => {
                        if (outageEventTypes.includes(eventType)) {
                          this.handleChange({
                            name: 'availCap',
                            value: '0',
                          })
                        } else {
                          if (!isNaN(e.target.value))
                            this.handleChange({
                              name: 'availCap',
                              value: e.target.value,
                            })
                        }
                      }}
                    />
                  </SubDiv>
                  <SubDiv>
                    <Labeled>
                      <span style={{ color: 'red' }}>*</span>
                      {' Cause Code: '}
                    </Labeled>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '2fr 1fr',
                        gridColumnGap: '10px',
                      }}
                    >
                      <Tooltip title={causeCodeMap[causeCode]}>
                        <Input
                          style={{
                            width: 'auto',
                            backgroundColor:
                              causeCode >= 9180 && causeCode <= 9199
                                ? 'rgb(194,57,237,0.5)'
                                : undefined,
                          }}
                          key="causeCode"
                          disabled={disableComp || disableCOPUEVentTypeView}
                          value={causeCode || ''}
                          placeholder="Cause Code"
                          name="causeCode"
                          min={-1}
                          onChange={e =>
                            this.handleChange({
                              name: 'causeCode',
                              value: e.target.value,
                            })
                          }
                          // title={causeCodeMap[causeCode]}
                        />
                      </Tooltip>
                      <Button
                        style={{ marginLeft: '5px' }}
                        disabled={disableComp || disableCOPUEVentTypeView}
                        primary
                        onClick={() => {
                          if (
                            this.state.unit === undefined ||
                            this.state.utility === undefined
                          ) {
                            message.info('Please, Select Utility and Unit')
                            return
                          }
                          this.openCauseCodePrompt(true)
                        }}
                      >
                        Select
                      </Button>
                    </div>
                  </SubDiv>
                  <SubDiv>
                    <Labeled
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'auto 100px',
                      }}
                    >
                      {'Fail/Amp. Code: '}
                      <Button
                        style={{ marginLeft: '5px' }}
                        primary
                        onClick={() => this.openFailCodePrompt(true)}
                        disabled={
                          disableFailAmpCode || disableCOPUEVentTypeView
                        }
                      >
                        Select
                      </Button>{' '}
                    </Labeled>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr',
                        gridColumnGap: '10px',
                        gridRowGap: '5px',
                      }}
                    >
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '50px auto',
                        }}
                      >
                        <div
                          style={{ display: 'grid', alignContent: 'center' }}
                        >
                          Fail :
                        </div>
                        <Select
                          style={{ marginTop: '2px', maxWidth: '400px' }}
                          showSearch
                          key="failCode"
                          value={(failCode && failCode.trim()) || 'NONE'}
                          placeholder="Fail Code"
                          name="failCode"
                          onChange={value => {
                            if (value === 'NONE') {
                              this.handleChange({
                                name: 'failCode',
                                value: undefined,
                              })
                            } else {
                              this.handleChange({
                                name: 'failCode',
                                value,
                              })
                            }
                          }}
                          // disabled={this.state.failCodeEnable}
                          disabled={
                            disableFailAmpCode || disableCOPUEVentTypeView
                          }
                        >
                          <Select.Option key="NONE" value="NONE">
                            NONE
                          </Select.Option>
                          {Object.keys(this.props.failCodeMap).map(k => (
                            <Select.Option key={k} value={k}>
                              {this.props.failCodeMap[k]}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>

                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '50px auto',
                        }}
                      >
                        <div
                          style={{
                            display: 'grid',
                            alignContent: 'center',
                          }}
                        >
                          Amp :
                        </div>
                        <Select
                          style={{ maxWidth: '400px' }}
                          showSearch
                          key="ampCode"
                          value={(ampCode && ampCode.trim()) || 'NONE'}
                          // value={(ampCode && ampCode.trim()) || ''}
                          placeholder="Amp Code"
                          name="ampCode"
                          onChange={value => {
                            if (value === 'NONE') {
                              this.handleChange({
                                name: 'ampCode',
                                value: undefined,
                              })
                            } else {
                              this.handleChange({
                                name: 'ampCode',
                                value,
                              })
                            }
                          }}
                          disabled={
                            disableFailAmpCode || disableCOPUEVentTypeView
                          }
                        >
                          <Select.Option key="NONE" value="NONE">
                            NONE
                          </Select.Option>
                          {Object.keys(this.props.amplification).map(k => (
                            <Select.Option key={k} value={k}>
                              {this.props.amplification[k]}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </SubDiv>
                  <div style={{ display: 'grid', gridRowEnd: 'span 1' }}>
                    <SubDiv style={{ marginTop: '10px' }}>
                      <Labeled>{'Contribution Code: '}</Labeled>
                      <Select
                        style={{ width: '100%' }}
                        key="conCode"
                        disabled={disableComp || disableCOPUEVentTypeView}
                        value={conCode || ''}
                        placeholder="Contribution Code"
                        name="conCode"
                        onChange={value =>
                          this.handleChange({ name: 'conCode', value })
                        }
                        selection
                      >
                        {conCodes.map(e => (
                          <Select.Option key={e.value} value={e.value}>
                            {e.value} - {e.text}
                          </Select.Option>
                        ))}
                      </Select>
                    </SubDiv>
                    <SubDiv style={{ marginTop: '10px' }}>
                      <Labeled>
                        {isRequiredContribOperCond ? (
                          <span style={{ color: 'red' }}>*</span>
                        ) : (
                          ''
                        )}{' '}
                        {'Contributing Operating Condition: '}
                      </Labeled>
                      <Select
                        style={{ width: '100%' }}
                        key="conCode"
                        disabled={disableComp}
                        value={
                          extensionData.eventTypeExternal
                            ? extensionData.eventTypeExternal
                            : mode === 'E'
                            ? '0'
                            : ''
                        }
                        name="conCode"
                        onChange={value => {
                          this.handleExtensionData('eventTypeExternal', value)
                        }}
                        selection
                      >
                        {R.sortBy(R.prop('code'), contribConditionList).map(
                          e => (
                            <Select.Option key={e.code} value={e.code}>
                              {e.code} - {e.description}
                            </Select.Option>
                          )
                        )}
                      </Select>
                    </SubDiv>
                  </div>
                  {this.showManHours && (
                    <SubDiv style={{ marginTop: '10px' }}>
                      <Labeled>{'Man Hours: '}</Labeled>
                      <InputNumber
                        style={{ width: '100%' }}
                        key="manHour"
                        disabled={disableComp || disableCOPUEVentTypeView}
                        value={manHour || ''}
                        placeholder="Man Hours"
                        name="manHour"
                        onChange={value =>
                          this.handleChange({ name: 'manHour', value })
                        }
                      />
                    </SubDiv>
                  )}
                  {this.props.card97Dominant &&
                    this.state.card97DominantMap[this.state.unit] && (
                      <SubDiv style={{ marginTop: '10px' }}>
                        <Labeled>Dominant:</Labeled>
                        <Select
                          style={{ width: '100%' }}
                          disabled={disableDominant || disableCOPUEVentTypeView}
                          onChange={e => {
                            // this.setState({ ioCode: e })
                            this.handleChange({ name: 'ioCode', value: e })
                          }}
                          value={this.state.ioCode || ''}
                        >
                          <Select.Option value="-1">Yes</Select.Option>
                          <Select.Option value="0">No</Select.Option>
                        </Select>
                      </SubDiv>
                    )}

                  {CLIENT === CPS_CLIENT && (
                    <SubDiv style={{ gridColumnEnd: 'span 3' }}>
                      <Labeled>Mis-Operations :</Labeled>
                      <Switch
                        disabled={
                          disableComp ||
                          eventType === 'RS' ||
                          eventType === 'NC'
                        }
                        style={{ margin: '10px' }}
                        checked={this.state.extensionData.string7 === 'Y'}
                        onChange={checked =>
                          this.handleExtensionData(
                            'string7',
                            checked ? 'Y' : 'N'
                          )
                        }
                        checkedChildren="Relay Mis-Operations"
                        unCheckedChildren="Not Relay Mis-Operations"
                      />
                    </SubDiv>
                  )}
                  <SubDiv style={{ gridColumnEnd: 'span 3' }}>
                    <Labeled style={{}}>
                      Description: (NERC only accepts the first 60 characters of
                      this description)
                    </Labeled>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'auto 150px',
                        gridColumnGap: '50px',
                      }}
                    >
                      <Input.TextArea
                        allowClear
                        key="description"
                        disabled={disableDescription}
                        placeholder="Description"
                        name="description"
                        value={description || ''}
                        onChange={e =>
                          this.handleChange({
                            name: 'description',
                            value: e.target.value,
                          })
                        }
                        autoHeight={false}
                        rows={2}
                        maxLength={300}
                      />
                      <Button
                        style={{ height: 'auto' }}
                        // type="dashed"
                        onClick={_ => {
                          if (
                            this.state.causeCode === undefined ||
                            this.state.causeCode == null
                          ) {
                            message.info(
                              'Cause Code must be selected before using the wizard'
                            )
                            return
                          }
                          this.setState({ descWizard: true })
                        }}
                        disabled={disableDescription}
                      >
                        Desc. Wizard
                      </Button>
                    </div>
                  </SubDiv>
                </div>
                {/* <div>
                    {this.props.card97Dominant &&
                      this.props.extendedCard({
                        stateData: { ...this.state, utility, unit },
                        propsData: this.props,
                        handleChange: this.handleChange,
                      })}
                  </div> */}
              </Tabs.TabPane>
              {this.showMoreCause && (
                <Tabs.TabPane key="table" tab="Add More Cause" forceRender>
                  <Button
                    // style={{ margin: '0px 0px 0px 0px' }}
                    type="primary"
                    disabled={disableComp || eventType === 'RS'}
                    onClick={() =>
                      this.openLowerTablePrompt(true, idxData.length, 'new')
                    }
                  >
                    Add New Row
                  </Button>
                  <Table
                    columns={columns}
                    dataSource={idxData.map((d, idx) => ({
                      ...d,
                      key:
                        idx +
                        '' +
                        (d.causeCode || '') +
                        '' +
                        (d.conCode || '') +
                        '' +
                        (d.failCode || '') +
                        '' +
                        (d.ampCode || '') +
                        '' +
                        (d.description || '') +
                        (d.eventTypeExternal || ''),
                    }))}
                    // pagination={{ position: 'top' }}
                    pagination={false}
                    size="small"
                    // scroll={{ y: 50, x: 150 }}
                    disabled={disableComp || disableCOPUEVentTypeView}
                    // rowKey={['causeCode', 'conCode', 'failCode', 'ampCode', 'desc']}
                    rowKey={(d, idx = 1) =>
                      idx +
                      (d.causeCode || '') +
                      '' +
                      (d.conCode || '') +
                      '' +
                      (d.failCode || '') +
                      '' +
                      (d.ampCode || '') +
                      '' +
                      (d.description || '') +
                      (d.eventTypeExternal || '')
                    }
                    style={{ minHeight: '400px' }}
                    scroll={{ y: 400 }}
                  />
                </Tabs.TabPane>
              )}
              {/* {this.state.extensionSpec.avaliable && (
                <Tabs.TabPane key="extensions" tab="Extensions" forceRender>
                  <Card97Extension
                    spec={this.state.extensionSpec}
                    handleExtSave={this.handleExtensionData}
                    data={{ ...this.state.extensionData }}
                  />
                </Tabs.TabPane>
              )} */}

              {isAvaliableExtensionPanel(
                this.props.CLIENT || 'INTEG',
                this.state.extensionSpec
              ) && (
                <Tabs.TabPane key="extensions" tab="Extensions" forceRender>
                  {/* <this.ClintExtensionPanel
                    isAdmin={this.isAdmin}
                    spec={this.state.extensionSpec}
                    handleExtSave={this.handleExtensionData}
                    data={{ ...this.state.extensionData }}
                    mode={mode}
                    lock={lock}
                    disableComp={disableComp}
                  /> */}
                  {/* {this.ClintExtensionPanel({
                    isAdmin: this.isAdmin,
                    spec: this.state.extensionSpec,
                    handleExtSave: this.handleExtensionData,
                    data: this.state.extensionData,
                    allData: this.state,
                    mode: mode,
                    lock: lock,
                    disableComp: disableComp,
                  })} */}
                  {getExtensionPanel(this.props.CLIENT || 'INTEG')({
                    isAdmin: this.isAdmin,
                    spec: this.state.extensionSpec,
                    handleExtSave: this.handleExtensionData,
                    handleChange: this.handleChange,
                    data: this.state.extensionData,
                    allData: this.state,
                    mode: mode,
                    lock: lock,
                    disableComp: disableComp,
                    CLIENT: this.props.CLIENT,
                    units: this.props.units,
                    disableCOPUEVentTypeView,
                    targetInfo: this.props.apiTargetInfo,
                    setSpinning: this.props.setSpinning,
                    setError: this.props.setError,
                  })}
                </Tabs.TabPane>
              )}

              {/* <Tabs.TabPane key="desc-wizard" tab="Desc. Wizard" forceRender>
                <DescWizard
                  targetInfo={this.props.apiTargetInfo}
                  utility={this.state.utility}
                  unit={this.state.unit}
                  causeCode={this.state.causeCode}
                  causeCodeDescription={causeCodeMap[this.state.causeCode]}
                  description={this.state.description}
                />
              </Tabs.TabPane> */}

              {/* {this.props.extendedCard &&
                this.props.extendedCard({
                  stateData: this.state,
                  propsData: this.props,
                  handleChange: this.handleChange,
                })} */}
            </Tabs>
          </Spin>
        </Modal>

        {msg && (
          <GenericModal key="msg" title="Message" open onClose={this.onClose}>
            {() => msg}
          </GenericModal>
        )}
        {errorPrompt && (
          <CardsErrorDialog
            retrieveData={this.props.retrieveData}
            keys="card97errordialog"
            errors={errors}
            onlyWarning={onlyWarning}
            // closeErrorPrompt={this.closeErrorPrompt}
            action={this.state.action}
            visible={errorPrompt}
            closeErrorPrompt={_ =>
              this.setState({ errorPrompt: false, errors: [] })
            }
            setShowEditDialog={_ =>
              this.state.againNew ? _ => _ : this.props.setEditPromptvisible()
            }
            allowRetrieve={this.props.allowRetrieve}
          />
        )}
        {failCodeDialog && (
          <FailCodePrompt
            key="card97failcodeprompt"
            setFailAmpCode={this.setFailAmpCode}
            openFailCodePrompt={this.openFailCodePrompt}
            ampCodeMap={ampCodeMap}
            failCodeMap={failCodeMap}
            failCode={failCode}
            ampCode={ampCode}
            visible={failCodeDialog}
          />
        )}
        {tableFailCodeDialog && (
          <FailCodePrompt
            key="card97tablefailcodeprompt"
            setFailAmpCode={this.setTableFailAmpCode}
            openFailCodePrompt={this.openTableFailCodePrompt}
            ampCodeMap={ampCodeMap}
            failCodeMap={failCodeMap}
            failCode={
              idxData[this.state.tableRowIndex] &&
              idxData[this.state.tableRowIndex].failCode
            }
            ampCode={
              idxData[this.state.tableRowIndex] &&
              idxData[this.state.tableRowIndex].ampCode
            }
          />
        )}
        {this.state.descWizard && this.state.causeCode && (
          <DescWizard
            targetInfo={this.props.apiTargetInfo}
            utility={this.state.utility}
            unit={this.state.unit}
            causeCode={this.state.causeCode}
            causeCodeDescription={causeCodeMap[this.state.causeCode]}
            description={this.state.description}
            onOk={this.onDescWizardDialogClosed}
            onCancel={_ => this.setState({ descWizard: false })}
            visible={this.state.descWizard}
            setEditPromptvisible={this.props.setEditPromptvisible}
            setError={this.props.setError}
          />
        )}
        {causeCodeDialog && (
          <MultiCauseCodePropmt
            key="card97editcausecodeprompt"
            // style={{ ...inlineStyle }}
            // checkable={false}
            visibleDialog={this.state.causeCodeDialog}
            onDialogClose={this.onCauseCodeDialogClose}
            onCancelAction={this.onCauseCodeTreeCancel}
            // defaultExpandedKeys={causeCode ? causeCode.selectedKeys : []}
            // defaultExpandedKeys={this.state.causeCodeKeyValues ? this.state.causeCodeKeyValues : []}
            // selectedKeys={this.state.causeCodeKeyValues ? this.state.causeCodeKeyValues : []}
            selectedKeys={this.state.causeCodeKeyValues}
            selectedValues={this.state.causeCodeValues}
            // selectedValues={this.state.causeCodeValues || []}
            unitCodes={
              this.props.unitCodeMap ? [this.props.unitCodeMap[unit]] : []
            }
            multiple={false}
            checkable={false}
            selectable
            causeCodeValue={[this.state.causeCode]}
            causeCodeList={this.props.causeCodeList}
          />
        )}
        {lowerTableDialog && (
          <LowerTablePrompt
            key="card97lowertableprompt"
            unit={this.state.unit}
            utility={this.state.utility}
            year={this.state.year}
            setLowerTableData={this.setLowerTableData}
            openLowerTablePrompt={this.openLowerTablePrompt}
            ampCodeMap={ampCodeMap}
            failCodeMap={failCodeMap}
            tableRowData={idxData[this.state.tableRowIndex]}
            tableMode={this.state.tableMode}
            unitCode={this.props.unitCodeMap && this.props.unitCodeMap[unit]}
            lowerTableDialog={lowerTableDialog}
            getExpandedKeys={getExpandedKeys(
              this.props.unitCodeCauseCodeMap || {}
            )}
            /* failCode={
            idxData[this.state.tableRowIndex] && idxData[this.state.tableRowIndex]['failCode']
          }
          ampCode={
            idxData[this.state.tableRowIndex] && idxData[this.state.tableRowIndex]['ampCode']
          } */
            causeCodeList={this.props.causeCodeList}
            contribConditionList={this.state.contribConditionList}
            contribConditionMap={this.state.contribConditionMap}
            eventType={this.state.eventType}
          />
        )}
      </div>
    )
  }
}

// const dominantEnable = ({ card97Dominant, list = [], utility, unit }) => {
//   if (card97Dominant) {
//     const listData = list.find(u => {
//       const v =
//         u.utility === utility &&
//         u.unit === unit.substring(utility.length) &&
//         ['MISO', 'NERC'].includes(u.ruleSet)

//       return v
//     })

//     return listData != undefined
//   }
//   return false
// }

const mapStateToProps = state => ({
  failCodeMap: getFailCode(state),
  isAdminType: isAdminType(state),
  amplification: getAmlificationCode(state),
  eventTypes: getEventTypes(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  units: getUnits(state),
  causeCodeMap: getCauseCodeMap(state),
  contribConditionList: getContribOperCondition(state),
  contribConditionMap: getContribOperConditionMap(state),
})

const Card97EditDdialog = connect(mapStateToProps)(Card97EditPrompt)

export default props => (
  <SpinContext.Consumer>
    {({ spinning, setSpinning }) => (
      <ErrorContext.Consumer>
        {({ error, setError }) => (
          <Card97EditDdialog
            spinning={spinning}
            setSpinning={setSpinning}
            error={error}
            setError={setError}
            {...props}
          />
        )}
      </ErrorContext.Consumer>
    )}
  </SpinContext.Consumer>
)
// export default Card97EditPrompt
